module.exports = __webpack_public_path__ + "img/ic_delete_24px.89862ff0.svg";